var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex bg-transparent justify-between px-4 sm:px-8 lg:px-8 border-primary-color border-solid flex-1 pt-2",
    },
    [
      _c("OpenButton", {
        staticClass:
          "text-gray-800 fill-current openBtn focus:outline-none sm:mr-2",
        attrs: { sidebarOpen: _vm.sidebarOpen },
        on: {
          click: function ($event) {
            return _vm.$emit("openSidebar")
          },
        },
      }),
      _c("nav", { staticClass: "ml-auto" }, [
        _c("div", { staticClass: "flex items-center justify-end h-16" }, [
          _c("div", { staticClass: "sm:ml-auto" }, [
            _vm.auth
              ? _c(
                  "div",
                  { staticClass: "flex items-center" },
                  [
                    _c("NotificationDropdown", {
                      attrs: { currentUserId: _vm.currentUser.id },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-white font-bold text-lg mx-2 sm:mx-4 flex flex-col",
                      },
                      [
                        _c("span", { staticClass: "text-gray-900" }, [
                          _vm._v(_vm._s(_vm.displayName)),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.businessName,
                                expression: "businessName",
                              },
                            ],
                            staticClass:
                              "text-sm font-medium leading-none text-gray-500",
                          },
                          [_vm._v(" " + _vm._s(_vm.businessName) + " ")]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideMenu,
                            expression: "hideMenu",
                          },
                        ],
                        staticClass: "relative outline-none",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex gap-4 items-center" },
                          [
                            _c("NavbarAvatar", {
                              staticClass: "user-profile-avatar",
                              attrs: {
                                avatar: _vm.userAvatar,
                                title: _vm.userFullname,
                                pointer: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.toggleUserMenu.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            }),
                            _vm.isAdmin
                              ? _c("NavbarAvatar", {
                                  attrs: {
                                    avatar: _vm.companyAvatar,
                                    title: _vm.companyTitle,
                                    pointer: "",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.toggleCompanyMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isManager
                              ? _c("NavbarAvatar", {
                                  attrs: {
                                    avatar: _vm.companyAvatar,
                                    title: _vm.companyTitle,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.currentUser && _vm.open
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "origin-top-right absolute right-0 mt-2 w-52 shadow-lg z-10 outline-none",
                                },
                                _vm._l(
                                  _vm.menu,
                                  function ({ name, title, icon }, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "bg-white" },
                                      [
                                        _c("RouterLink", {
                                          staticClass:
                                            "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-primary-500 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out cursor-pointer",
                                          attrs: { to: { name }, custom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ navigate }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "inline-flex h-10 items-center w-full text-gray-800 iconContainer",
                                                        on: {
                                                          click: _vm.hideMenu,
                                                          mousedown: navigate,
                                                        },
                                                      },
                                                      [
                                                        _c(icon, {
                                                          tag: "component",
                                                          staticClass:
                                                            "fill-icon-primary text-white mr-2 transition duration-150 ease-in-out",
                                                          class:
                                                            _vm.iconSize(icon),
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(title) +
                                                              " "
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }